module.exports = __webpack_public_path__ + "static/media/JPY.0e4b2b3e.svg";